var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "container" },
        [
          _vm.paineis && _vm.paineis.length > 0
            ? _c("listagem-paineis", {
                attrs: { paineis: _vm.paineis, isMyProject: false },
                on: { openModal: _vm.openModal }
              })
            : _vm._e()
        ],
        1
      ),
      _vm.modal
        ? _c("modal-cadastro-painel", {
            attrs: { idPainel: _vm.idPainel },
            on: {
              closeModal: function($event) {
                return _vm.closeModal()
              },
              refreshList: function($event) {
                return _vm.getMyProjects()
              }
            }
          })
        : _vm._e(),
      _c("div", { staticClass: "container-center" }, [
        _vm.paineis && _vm.paineis.length == 0
          ? _c("div", [
              _c("div", { staticClass: "alert" }, [
                _vm._v("Nenhum painel compartilhado até o momento")
              ])
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-361eb4b9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-361eb4b9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/demandas/components/PaineisCompartilhados.vue
// module id = null
// module chunks = 